export default __webpack_public_path__ + "static/media/C0003.99f41421.png";